export default "__VITE_ASSET__BRjn8h_7__"